import React from "react";
import { Button } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import Ticker from "../Ticker";

/** Single horizontal row: short primary line + optional second line to save width */
const STEPS = [
  { key: "cat", lines: ["Category"], aria: "Category — new or established patient" },
  { key: "loc", lines: ["Location"], aria: "Location — your state" },
  { key: "prov", lines: ["Provider"], aria: "Provider" },
  { key: "svc", lines: ["Service"], aria: "Service — visit type" },
  {
    key: "pat",
    lines: ["Your", "details"],
    aria: "Your information — patient details",
  },
  {
    key: "ques",
    lines: ["Health", "questions"],
    aria: "Health questionnaire",
  },
  { key: "sched", lines: ["Schedule"], aria: "Schedule — date and time" },
  { key: "conf", lines: ["Confirm"], aria: "Confirm booking" },
];

export default function Stepper({ currentStep, onBack }) {
  return (
    <>
      <Ticker />
      <div className="stepper-container stepper-container--row">
        <div
          className={`stepper stepper--row${
            currentStep > 0 ? " stepper--row-has-back" : ""
          }`}
          role="list"
          aria-label="Booking progress"
        >
          {STEPS.map((stepDef, index) => {
            const stepNum = index;
            const isActive = stepNum === currentStep;
            const isCompleted = stepNum < currentStep;
            const isCategoryStep = index === 0;

            return (
              <div
                key={stepDef.key}
                className={`step step--row${isCompleted ? " step--row-completed" : ""}${
                  isActive ? " step--row-active" : ""
                }`}
                role="listitem"
                aria-label={stepDef.aria}
                aria-current={isActive ? "step" : undefined}
                style={isCategoryStep ? { position: "relative" } : {}}
              >
                <div className="step-row-inner">
                  <div
                    className={`step-circle step-circle--row ${
                      isCompleted ? "completed" : isActive ? "active" : ""
                    }`}
                  >
                    {isCompleted ? "✓" : stepNum + 1}
                  </div>
                  <div className="step-label-stack" aria-hidden="true">
                    {stepDef.lines.map((line, i) => (
                      <span
                        key={i}
                        className={
                          i === 0
                            ? "step-label-line step-label-line--primary"
                            : "step-label-line step-label-line--secondary"
                        }
                      >
                        {line}
                      </span>
                    ))}
                  </div>
                </div>
                {isCategoryStep && currentStep > 0 && onBack && (
                  <div className="stepper-category-back">
                    <Button
                      className="btn-css-class"
                      onClick={onBack}
                      size="small"
                      icon={<LeftOutlined />}
                      shape="circle"
                      aria-label="Go back one step"
                      style={{
                        width: "32px",
                        height: "32px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
